require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-build-a-simon-game.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-build-a-simon-game");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-build-a-simon-game!./.cache/json/coding-interview-prep-take-home-projects-build-a-simon-game.json
// module id = 1924
// module chunks = 231608221292675